import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css']
})
export class DeleteUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
